import React, { useEffect } from 'react';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

export default function NextUpReviewPageButton({ buttonText }) {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const {
    pageContentResource,
    loadPageContentLink,
    pageContentLoadingError,
    isPageContentLoading,
  } = usePageContentContext();

  useEffect(() => {
    if (!pageContentLoadingError) {
      return;
    }
    if (pageContentLoadingError.errors) {
      displayErrorMessage(pageContentLoadingError, pageContentLoadingError.errors);
    } else {
      displayErrorMessage(pageContentLoadingError, 'Failed to go to next up review page, please try again.');
    }
  }, [pageContentLoadingError]);

  return (
    <FDPrimaryActionButton
      disabled={isSubmitting || isPageContentLoading}
      loading={isSubmitting}
      onClick={async () => {
        setIsSubmitting(true);
        try {
          await loadPageContentLink(pageContentResource.relationship(fr.relationships.nextUpReviewPage.name).link('related'));
        } catch (err) {
          displayErrorMessage(err, err.errors);
        } finally {
          setIsSubmitting(false);
        }
      }}
      size={'lg'}
      label={buttonText}
      {...dataAttrs('next-up-review-page-button')}
    />
  );
}

NextUpReviewPageButton.defaultProps = {
};

NextUpReviewPageButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
};
